<div class="error-prompt-footer">
  <ng-content></ng-content>
</div>
